var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMusicFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected Icon",
    clipPath: "url(#clip0_0_90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7778 0.0834227C11.8912 0.165728 11.9583 0.297376 11.9583 0.437503V9.04167H11.9563C11.9957 9.82823 11.4639 10.7122 10.5519 11.2427C9.36968 11.9305 7.99626 11.7638 7.48433 10.8703C6.9724 9.97689 7.5158 8.69504 8.69806 8.00725C9.51832 7.53006 10.4306 7.46421 11.0833 7.76701V3.90605L5.25 5.76211V11.375H5.24795C5.25 12.25 4.75555 13.0456 3.8436 13.5761C2.66134 14.2639 1.28793 14.0971 0.775998 13.2037C0.264065 12.3102 0.807471 11.0284 1.98973 10.3406C2.80999 9.8634 3.72226 9.79754 4.375 10.1003V2.625C4.375 2.43564 4.49683 2.26777 4.67687 2.20906L11.3852 0.021559C11.5184 -0.0218834 11.6644 0.00111778 11.7778 0.0834227Z",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusicFilled);
export default __webpack_public_path__ + "static/media/iconMusicFilled.5a7d6cb0d0483fd9e6ca0cfdefb40a8f.svg";
export { ForwardRef as ReactComponent };